import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import Sites from "../../constants/Sites";
import {
  findSiteNameWithoutCom,
  modalClickFunction,
} from "../../helpers/Helper";
import NextImage from "@components/Image/NextImage";

import styles from "./FollowButton.module.css";

const Modal = dynamic(() => import("../Modal/Modal"));
const NewsLetterV2 = dynamic(() => import("../NewsletterV2/NewsletterV2"));

class FollowButton extends React.Component {
  author = "";
  state = {
    open: false,
    loading: false,
    displayError: false,
    isFromSlider: false,
  };

  componentDidMount() {
    this.setState({ isFromSlider: this.props.fromSlider });
    //Check if user comes from Author site's
    if (this.props.isMD) {
      this.handleFollowClick();
    }
  }
  onOpenModal = () => {
    if (this.props.fromSlider == true) {
      this.props.setOpen(true);
      this.props.setAuthor(this.props.author);
      this.props.setAuthorId(this.props.authorId);
    } else {
      this.setState({ open: true });
    }
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleFollowClick = async () => {
    if (
      this.props.subscriberCookie &&
      this.props.siteId === Sites.EARLYBIRDBOOKS
    ) {
      //Handle Follow author if user is already logged in
      const userEmail = this.props.subscriberCookie;
      const siteId = this.props.siteId;
      const firebrandId = this.props.authorId;
      const author = this.props.author;

      window.open(
        `/follow/author?fid=${firebrandId}&siteid=${siteId}&author=${author}&email=${userEmail}`,
        "_blank",
        "noopener"
      );
    } else {
      this.onOpenModal();
    }
  };

  render() {
    let { open } = this.state;
    this.author = "Get an email alert when this author’s titles go on sale!";
    return (
      <>
        <div
          className="author-follow-wrapper"
        //  title={this.author}
        >
          <div className="author-follow" onClick={this.handleFollowClick}>
            <div className={"author-icon " + this.props.classes}>
              {/* <Image */}
              <NextImage
                ImageUrl="https://orion-uploads.openroadmedia.com/frontend-assets/follow-icon.png"
                Title={this.author}
                Alt_Text={this.author}
                width={16}
                height={16}
                className={`author-icon-img ${this.props.classes ? this.props.classes : ""
                  }`}
                isLazyload={this.props.isLazyLoad}
              />
            </div>
            <span className="author-follow-text">Follow this author</span>
          </div>
          <div className="author-info-icon-wrapper">
            <span className={`${this.props.autherInfoIconStyles} ${styles["author-info-icon"]}`}>
              <NextImage publicUrl="/infoIcon.svg" width={17} height={17} Alt_Text="info icon" />
            </span>
          </div>
        </div>
        {this.props.fromSlider == false ? (
          <Modal
            isOpen={open}
            closeBtn={this.onCloseModal}
            sizeClass={"small"}
            transitionName={"follow-modal"}
          >
            <NewsLetterV2
              isChild={true}
              subComponentType={'modal'}
              classNames={"author-follow-newsletter"}
              isDisplayModalChecked={true}
              mainPost={false}
              // displayModalHeader={this.author}
              modalHeader={this.author}
              buttonText="Follow"
              buttonLoadingText="Following..."
              OptIn={true}
              optInNewsletter={{
                partnerCheckbox: true,
                optInSite: findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS), // Set optInSite here
                optInNewsletterCopy: "Yes! I also want to get the Early Bird Books newsletter featuring great deals on ebooks.",
                optInSiteSailthruLists: ['Early Bird Books'],
              }}
              primaryNewsletter={findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS)}
              siteId={Sites.EARLYBIRDBOOKS}
              authorId={this.props.authorId}
              followButton={true}
              closeModal={this.onCloseModal}
              eventName={this.props.eventName}
              authorName={this.props.author}
              titleISBN={this.props.titleISBN ? this.props.titleISBN : ""}
              modalClickFunction={() =>
                modalClickFunction(
                  this.props.author,
                  this.props.eventName,
                  this.props.titleISBN
                )
              }
            />
          </Modal>
        ) : (
          ""
        )}

        <style>{`
          .author-follow-wrapper {
            display: inline-flex;
            align-items: center;
            cursor: pointer;
          }
          .author-follow {
            display: inline-flex;
            margin-left: 10px;
            align-items: center;
            background-color: #f0f0f1;
            border: 1px solid #4a4a4a;
          }
          .author-icon {
            background-color: #1d66bf;
            padding: 5px 5px 3px 5px;
            position: relative;
            cursor: pointer;
            display: inline-block;
          }
          .author-follow .author-follow-text {
            padding: 0 8px;
            color: #4a4a4a;
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1.54px;
          }     
          .author-info-icon-wrapper {
              display: flex;
              position: relative;
          }
        `}</style>
        <style>
          {`
            .author-follow-newsletter.row
              .formGroup
              .newLetterContainer
              .buttonBox
              button {
              font-size: 14px;
            }
            @media (max-width: 767px) {
              .author-follow-newsletter.row
                .formGroup
                .newLetterContainer
                .buttonBox
                button {
                font-size: 17px;
              }
            }
          `}
        </style>
      </>
    );
  }
}

FollowButton.propTypes = {
  icon: PropTypes.bool,
  optInNewsletter: PropTypes.string,
  buttonText: PropTypes.string,
  author: PropTypes.string,
  authorIds: PropTypes.array,
  titleISBN: PropTypes.string,
  eventName: PropTypes.string,
  fromSlider: PropTypes.bool,
  isMobile: PropTypes.bool,
  isLazyLoad: PropTypes.bool,
};

FollowButton.defaultProps = {
  fromSlider: false,
  isMobile: false,
  isLazyLoad: true,
};

export default FollowButton;